import { Button, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';

export default function Channel({
  icon,
  name,
  active,
  disabled,
  tooltip,
  onClick,
}) {
  const bgColorByActiveStatus = {
    true: 'rgba(0, 125, 255, 0.08)',
    false: theme => theme.palette.primary.contrastText,
  };

  const colorByActiveStatus = {
    false: theme => theme.palette.action.active,
  };

  const borderColorByActiveStatus = {
    false: theme => theme.palette.divider,
  };

  const colorTypographyByActiveStatus = {
    true: 'primary',
    false: 'text.secondary',
  };

  const channel = (
    <Stack alignItems="center" gap={0.5}>
      <Button
        variant="outlined"
        disabled={disabled}
        onClick={onClick}
        sx={{
          bgcolor: bgColorByActiveStatus[active],
          p: 2,
          color: colorByActiveStatus[active],
          borderColor: borderColorByActiveStatus[active],
        }}
      >
        {icon}
      </Button>
      <Typography
        color={
          (!disabled && colorTypographyByActiveStatus[active]) ||
          'text.disabled'
        }
      >
        {name}
      </Typography>
    </Stack>
  );

  if (tooltip)
    return (
      <Tooltip title={tooltip} arrow>
        {channel}
      </Tooltip>
    );

  return channel;
}
